module.exports = __webpack_public_path__ + "static/media/apiStruct.1a807d9e.png";